import type { CommuteRequest, CommuteSnapshot } from "../shared/types";

export class ApiError extends Error {}

export async function fetchSnapshot(request: CommuteRequest, signal: AbortSignal): Promise<CommuteSnapshot> {
	const response = await fetch("/api/commute", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(request),
		signal,
	});

	if (!response.ok) {
		const body = (await response.json().catch(() => null)) as { error?: { message?: string } } | null;
		throw new ApiError(body?.error?.message ?? `Request failed (${response.status})`);
	}

	return (await response.json()) as CommuteSnapshot;
}
